// Э-4. Шахматка: этажи × захватки, цвет — статус; клик по ячейке — работы захватки с план/факт.

import { useState } from "react";
import { useLive } from "../../shared/live";
import { TopBar } from "../../shared/shell";
import { Drawer, Legend, Loading, useAsync } from "../../shared/ui";
import { Chessboard, GripScheme, TaskLine, type GridData } from "../components";
import { api, CHESS_LEGEND, floorName, live } from "../ctx";

export function GridPage({ id }: { id: string }) {
  const g = useAsync<GridData>(() => api.get(`/buildings/${id}/grid`), [id]);
  const grips = useAsync<any[]>(() => api.get(`/buildings/${id}/grips`), [id]);
  const [sel, setSel] = useState<{ floor: number; grip: string } | null>(null);
  useLive(live, ["report.", "cycle."], () => g.reload(), 1000);
  const cur = g.data?.rows.slice().reverse().find((r) => r.status !== "done")?.floor;
  const cell = sel && g.data?.rows.find((r) => r.floor === sel.floor)?.cells.find((c) => c.grip === sel.grip);
  return (
    <>
      <TopBar title="Шахматка" />
      <div className="content">
        {!g.data ? <Loading error={g.error} onRetry={g.reload} /> : (
          <div className="panel pad stack" style={{ overflowX: "auto" }}>
            <div className="fills"><Legend items={CHESS_LEGEND} /></div>
            <Chessboard data={g.data} current={cur} onCell={(floor, grip) => setSel({ floor, grip })} />
            <p className="muted small">С — захватки стен, П — захватки перекрытия (граница — рабочий шов бетонирования). Число в ячейке — средний процент выполнения работ захватки.</p>
          </div>
        )}
      </div>
      {sel && cell && (
        <Drawer narrow title={`${floorName(sel.floor)}, захватка ${sel.grip}`} onClose={() => setSel(null)}>
          <div className="stack">
            <div>{(cell.tasks || []).map((t: any) => <TaskLine key={t.id} t={t} />)}</div>
            <SchemeOf grips={grips.data || []} code={sel.grip} />
          </div>
        </Drawer>
      )}
    </>
  );
}

/** Где захватка на плане этажа (если администратор загрузил схему в шаблоне).
 * Соседи — только той же группы: стены со стенами, перекрытие с перекрытием (иначе рамки накладываются). */
function SchemeOf({ grips, code }: { grips: any[]; code: string }) {
  const g = grips.find((x) => x.code === code);
  if (!g?.scheme_url) return null;
  const others = grips.filter((x) => x.code !== code && x.group === g.group && x.zone && x.scheme_url === g.scheme_url).map((x) => ({ code: x.code, zone: x.zone }));
  return (
    <div className="stack tight">
      <h3>Захватка на плане этажа</h3>
      <GripScheme url={`${g.scheme_url}?token=${api.token}`} zone={g.zone} label={code} others={others} />
      {g.note && <div className="muted small">{g.note}</div>}
    </div>
  );
}
